import { gql } from "@apollo/client";

export const GET_IT_APPS_MATRIX = gql`
  query GetItApllicationsDivisionDashboard {
    getItApllicationsDivisionDashboard {
      divisions {
        applications {
          name
          supportsRevenue
          uuid
          value {
            percentage
            revenue
          }
          description
        }
        name
        productGroups {
          applications {
            name
            supportsRevenue
            uuid
            value {
              percentage
              revenue
            }
          }
          name
          products {
            applications {
              name
              supportsRevenue
              uuid
              value {
                percentage
                revenue
              }
            }
            name
            revenue
            uuid
          }
          revenue
          uuid
        }
        revenue
        uuid
      }
    }
  }
`;

export const FETCH_IT_APPS = gql`
  query FindAllItApplications($data: FilterInput) {
    findAllItApplications(data: $data) {
      uuid
      application
      applicationType
    }
  }
`;

export const SET_IT_APP_DEPENDENCY_PERCENTAGE = gql`
  mutation SetDependencyPercentage($data: SetDivisionDependencyDataInput!) {
    setDependencyPercentage(data: $data)
  }
`;

export const UPDATE_SELECTED_IT_APPS = gql`
  mutation SelectItApplications($data: SelectItApplicationsInput!) {
    selectItApplications(data: $data)
  }
`;

export const GET_IT_APPS_SUMMARY = gql`
  query GetItApplicationsSummary {
    getItApplicationsSummary {
      uuid
      applicationDescription
      name
      percentageOfCompanySupported
      revenueSupportedAnnualy
    }
  }
`;

